import { render, staticRenderFns } from "./TermsLinks.vue?vue&type=template&id=54ffa60c&scoped=true&"
import script from "./TermsLinks.vue?vue&type=script&lang=js&"
export * from "./TermsLinks.vue?vue&type=script&lang=js&"
import style0 from "./TermsLinks.vue?vue&type=style&index=0&id=54ffa60c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ffa60c",
  null
  
)

export default component.exports